/* src/app/shared/components/data-table/data-table.component.scss */
.table-container {
  width: 100%;
  overflow: hidden;
}
.table-title {
  font-size: 20px;
  font-weight: 700;
  color: var(--cds-text-strong);
  margin: 0 0 24px 0;
}
.table-wrapper {
  overflow-x: auto;
}
.investments-table {
  width: 100%;
  border-collapse: collapse;
}
.investments-table.table-plain-rows .table-row,
.investments-table.table-plain-rows .table-row:hover,
.investments-table.table-plain-rows .table-row:nth-child(even),
.investments-table.table-plain-rows .table-row:nth-child(odd) {
  background: var(--cds-background-main);
}
.investments-table.table-plain-rows .table-row .table-cell,
.investments-table.table-plain-rows .table-row:nth-child(even) .table-cell,
.investments-table.table-plain-rows .table-row:nth-child(odd) .table-cell {
  background: var(--cds-background-main);
}
.table-header {
  background: var(--cds-background-accent);
  padding: 24px 16px;
  text-align: left;
  font-weight: 600;
  font-size: 18px;
  color: var(--cds-text-strong);
  border-bottom: 1px solid var(--cds-border);
  position: relative;
  cursor: default;
}
.table-header.sortable {
  cursor: pointer;
}
.header-content {
  display: flex;
  align-items: center;
  gap: 8px;
}
.header-content.text-left {
  justify-content: flex-start;
}
.header-content.text-center {
  justify-content: center;
}
.header-content.text-right {
  justify-content: flex-end;
}
.header-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
}
.table-cell {
  padding: 16px 12px;
  border-bottom: 1px solid var(--cds-border);
  vertical-align: middle;
  background: var(--cds-background-main);
  color: var(--cds-text-strong);
}
.table-cell a {
  color: var(--cds-text-strong);
}
.table-row {
  cursor: pointer;
  transition: background-color 0.15s ease;
}
.table-row:hover {
  background: var(--cds-foreground-20);
}
.table-row:nth-child(even) {
  background: var(--cds-background-accent);
}
.table-row:nth-child(even) .table-cell {
  background: var(--cds-background-accent);
}
.table-row:nth-child(odd) {
  background: var(--cds-background-main);
}
.table-row:nth-child(odd) .table-cell {
  background: var(--cds-background-main);
}
.table-row:last-child .table-row {
  border-bottom: none;
}
.actions-header {
  text-align: center;
}
.actions-cell {
  text-align: center;
}
.actions-content {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}
.action-button {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: var(--cds-text-strong);
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s ease;
  border: none;
  background: none;
}
.action-button.action-solid {
  color: var(--cds-text-strong);
}
.action-button.action-sm {
  font-size: 12px;
}
.action-button.action-md {
  font-size: 14px;
}
.action-button.action-lg {
  font-size: 18px;
}
.action-label {
  display: none;
}
.logo-cell {
  display: flex;
  align-items: center;
}
.table-cell.text-left .logo-cell {
  justify-content: flex-start;
}
.table-cell.text-center .logo-cell {
  justify-content: center;
}
.table-cell.text-right .logo-cell {
  justify-content: flex-end;
}
.logo-circle {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--cds-primary-contrast);
  font-weight: 600;
  font-size: 12px;
}
.logo-text {
  line-height: 1;
}
.logo-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 50%;
}
.currency-value {
  font-weight: 500;
}
.currency-value.positive {
  color: var(--cds-revenue);
}
.currency-value.negative {
  color: var(--cds-expense);
}
.currency-value.currency-dark {
  color: var(--cds-text-strong);
}
.currency-value.currency-expense {
  color: var(--cds-expense);
}
.status-content {
  display: flex;
  gap: 8px;
  align-items: center;
}
.table-cell.text-left .status-content {
  justify-content: flex-start;
}
.table-cell.text-center .status-content {
  justify-content: center;
}
.table-cell.text-right .status-content {
  justify-content: flex-end;
}
.status-text {
  font-weight: 500;
  font-size: 14px;
  padding: 4px 12px;
  border-radius: 8px;
  color: var(--cds-text-strong);
}
.status-text.status-available {
  background: color-mix(in srgb, var(--cds-revenue) 14%, var(--cds-background-main));
}
.status-text.status-unavailable {
  background: color-mix(in srgb, var(--cds-expense) 14%, var(--cds-background-main));
}
.status-text.status-default {
  background: transparent;
}
.text-left {
  text-align: left;
}
.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}
.text-muted {
  color: var(--cds-text-light);
}
.text-primary {
  color: var(--cds-text-primary);
}
.custom-cell-content {
  display: inline;
}
.custom-cell-content-between {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
}
::ng-deep .custom-cell-action-button {
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: none;
  background: none;
}
::ng-deep .custom-cell-action-icon {
  font-size: 12px;
  color: var(--cds-icon-medium);
}
.cds-icon-sm {
  width: 16px;
  height: 16px;
}
.cds-icon-lg {
  width: 24px;
  height: 24px;
}
/*# sourceMappingURL=data-table.component.css.map */
